// Deep-merge helper used by `app/javascript/dashboard/i18n/index.js` to layer
// any locale overrides found under `custom/app/javascript/dashboard/i18n/locale/`
// on top of the OSS bundles. Keys present in the custom layer win; everything
// else falls through to the upstream translations.

const isPlainObject = value =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

export const mergeLocales = (base, overrides) => {
  if (!isPlainObject(overrides)) return base;
  return Object.keys(overrides).reduce(
    (result, key) => {
      const baseValue = base?.[key];
      const overrideValue = overrides[key];
      result[key] =
        isPlainObject(baseValue) && isPlainObject(overrideValue)
          ? mergeLocales(baseValue, overrideValue)
          : overrideValue;
      return result;
    },
    { ...base }
  );
};

// Convert the eager glob result into a `{ <lang>: <messages> }` map. The glob
// path looks like `/custom/app/javascript/dashboard/i18n/locale/pt_BR/index.js`.
export const collectCustomLocales = globResult =>
  Object.entries(globResult).reduce((out, [path, module]) => {
    const match = path.match(/\/locale\/([^/]+)\/index\.js$/);
    if (match) out[match[1]] = module.default || module;
    return out;
  }, {});
